<template>
  <div class="login">
    <div class="login-main">
      <div class="login-main-title">
        <!-- <img src="../../../static/img/title.png" style="width:317px;" alt=""> -->
        <!-- <img src="../../../static/img/home/logo2.png" /> 数字思政AI云 -->
      </div>
      <div class="content">
        <div class="title">
          <loginVue @child-event="closeClick" />
          <div class="footer">
            <span @click="registerClick">注册账号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loginVue from "../components/login.vue";
export default {
  components: {
    loginVue,
  },
  data() {
    return {
      form: {},
      isShowCode: false,
      forgotDia: false
    };
  },

  created() {
    this.logon = true;
  },
  methods: {
    closeClick() {
      this.show = false;
      this.loginDia = false;
      this.forgotDia = false;
      this.logon = false;
    },
    registerClick() {
      this.$router.push({ path: "/register" });
    }
  }
};
</script>
<style lang="less" scoped>

/deep/ .el-dialog__body {
  padding: 0;
}

.login {
  background-image: url("../assets/register.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .login-main {
    &-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      margin: auto;


      img {
        width: 35px;
        margin-right: 20px;
      }
    }

    .content {
      width: 400px;
      // height: 646px;
      background: #ffffff;
      border-radius: 12px;
      margin: auto;
      // margin-top: 50px;
      padding:30px;
      text-align: center;

      .footer {
        font-size: 14px;
        margin-top: 17px;
        color: #4476EF;
        cursor: pointer;
      }
    }
  }
}
</style>
